import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const forgotPasswordSlice = createSlice({
  name: "forgotPasswordSlice",
  initialState: {
    message: undefined,
    dataFetchingStatus: false,
  },
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    removeElementsFromArray: (state, action) => {
      state.forgotPasswordRequestData = action.payload;
    },
  },
});

export const { setMessage, setDataFetchingStatus, removeElementsFromArray } =
  forgotPasswordSlice.actions;

export const forgotPasswordRequest = (data) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setMessage(undefined));
  dispatch(setDataFetchingStatus(true));
  axios
    .post("/forgotpassword", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setMessage(error.response.data.error));
    });
};
export const clearForgotPasswordData = () => (dispatch) => {
  dispatch(removeElementsFromArray({}));
};

export default forgotPasswordSlice.reducer;
